import getCookie from '../../js/getcookie';
import setCookie from '../../js/setcookie';

( function() {
  const SEL = {
    barWrapper: 'cc-notification-bar__wrapper',
    barWrapperActive: 'cc-notification-bar__wrapper--active',
    barClosingElement: 'cc-notification-bar__close',
  };

  const barWrapper = document.querySelector( `.${ SEL.barWrapper }` );
  if ( barWrapper ) {
    const barCookie = barWrapper.dataset.cookie;
    const barClosingElements = document.querySelectorAll( `.${ SEL.barClosingElement }` );

    if ( ! getCookie( barCookie ) ) {
      barWrapper.classList.add( `${ SEL.barWrapperActive }` );
    }

    if ( barClosingElements.length ) {
      barClosingElements.forEach( applyCloseEventListeners );

      function applyCloseEventListeners( closingElement ) {
        closingElement.addEventListener( 'click', () => {
          barWrapper.classList.remove( `${ SEL.barWrapperActive }` );
          setCookie( barCookie, 1, 7 );
        } );
      }
    }
  }
}() );
